import 'SF/profile/AppointmentPreferencesBasicPanel.js';
import 'SF/profile/AppointmentPreferencesCalendarManagerPanel.js';
import 'SF/profile/AppointmentPreferencesFormPanel.js';
import 'SF/profile/AppointmentPreferencesLocationGridPanel.js';
import 'SF/profile/AppointmentPreferencesLocationPanel.js';
import 'SF/profile/EmailInfoPanel.js';
import 'SF/profile/ExchangeFreeBusyInstructionsWindow.js';
import 'SF/profile/ExchangeOptInDisclaimer.js';
import 'SF/profile/GoogleFreeBusyInstructionsWindow.js';
import 'SF/profile/LocationWindow.js';
import 'SF/profile/ParentWindow.js';
import 'SF/profile/PhotoPanel.js';
import 'SF/profile/StudentNotificationPanel.js';
import 'SF/profile/StudentNotificationPreferencesPanel.js';
import 'SF/profile/StudentParentGridPanel.js';
import 'SF/profile/StudentParentPanel.js';
import 'SF/profile/StudentProfileDataPanel.js';
import 'SF/profile/StudentProfilePanel.js';
import 'SF/profile/bundle.js';
import 'SF/profile/data/LocationStore.js';
import 'SF/profile/data/ParentStore.js';
import 'SF/profile/data/StudentProfileStore.js';
